# Run this after every page load
$(document).ready(() ->
    # Show / hide fields
    initializeShowHideLinks()

    # Activity monitoring
    timeSource = D12App.createTimeSource()
    window.activity = new D12App.ActivityMonitor(timeSource)
    listenToActivityEvents()

    # Date inputs
    replaceDateInput()

    window.messageDisplay = new D12App.MessageDisplay()

    window.ajaxClient = new D12App.AjaxClient(baseurl, csrftoken)

    # Navbar
    if userid > 0
        window.notifications = new D12App.NotificationManager(window.ajaxClient)
        window.navBarUpdater =
            D12App.initializeNavBar(window.activity, window.ajaxClient, window.notifications, timeSource)

    window.bbCode = new D12App.BBCode()
)

window.initializeShowHideLinks = (parentIdentifier = '') ->
    # Unbind all the current click handlers, because I don't want doubles
    $("#{parentIdentifier} .show-hide-link").unbind('click')

    # Bind the click handler for the show hide links
    $("#{parentIdentifier} .show-hide-link").click(() ->
        slide = $(this).hasClass('slide')
        id = $(this).data('id')
        cls = $(this).data('class')
        defaultId = $(this).data('defaultId')
        defaultClass = $(this).data('defaultClass')
        el = $('#' + id)

        if el.is(':hidden')
            if cls
                if slide
                    $('.' + cls).slideUp()
                else
                    $('.' + cls).hide()
        else
            if defaultId
                if slide
                    $('#' + defaultId).slideDown()
                else
                    $('#' + defaultId).show()
        if defaultClass
            if slide
                $('.' + defaultClass).slideDown()
            else
                $('.' + defaultClass).show()
            if el.is(':hidden')
                el.parent().find('.' + defaultClass).hide()
        if slide
            el.slideToggle()
        else
            el.toggle()
        return false
    )

#
# Date input
#
supportsDateField = () ->
    input = $('<input type="date">')
    randomVal = 'hi-matty-i-think-you-lost-the-game'
    input.val(randomVal)

    ret = input.val() isnt randomVal
    input.remove()
    return ret

replaceDateInput = () ->
    if not $('input[type=date]')? or supportsDateField()
        return

    $('input[type=date]').each(() ->
        if $(this).is('[readonly]') or $(this).is('[disabled]')
            return

        # Wrap element in a div for markup.
        $(this).wrap('<div class="input-date"></div>')
        wrap = $(this).parent()

        # Turn date field hidden.
        $(this).attr('type', 'hidden')

        # Create selects.
        d = createDatePickElement('dd', 1, 31)
        m = createDatePickElement('mm', 1, 12)
        y = createDatePickElement('yyyy', 1900, moment().year())

        # Put them in DOM.
        wrap.append(d)
        wrap.append('-')
        wrap.append(m)
        wrap.append('-')
        wrap.append(y)

        # Keep hidden element updated.
        self = $(this)
        wrap.find('select').change(() ->
            if parseInt(y.val()) is 0 or parseInt(m.val()) is 0 or parseInt(d.val()) is 0
                self.val(null)
            else
                self.val(y.val() + '-' + ('0' + m.val()).slice(-2) + '-' + ('0' + d.val()).slice(-2))
            return true
        )

        # Fill in initial values.
        val = $(this).val()
        split = val.split('-')
        if split.length is 3
            y.val(parseInt(split[0]))
            m.val(parseInt(split[1]))
            d.val(parseInt(split[2]))
    )

createDatePickElement = (placeholder, min, max) ->
    str = '<select>'
    str += '<option selected="selected" value="0">' + placeholder + '</option>'
    for i in [min..max]
        str += '<option value="' + i + '">' + i + '</option>'
    str += '</select>'
    return $(str)

#
# Stop updates when activity is stopped
#
listenToActivityEvents = () ->
    window.activity.activityStarted.subscribe(() ->
        if chat?
            chat.update()
            chat.resetInterval()
        if lobby?
            lobby.update()
            lobby.resetInterval())
    window.activity.activityStopped.subscribe(() ->
        if chat?
            clearInterval(chat.updateLoop)
        if lobby?
            clearInterval(lobby.updateLoop))
